<template>
  <div class="project-selector">
    <div class="selector-header">
      <h2>项目选择</h2>
      <div class="header-actions">
        <el-button type="primary" @click="selectAll">全选</el-button>
        <el-button @click="clearAll">清空</el-button>
      </div>
    </div>
    
    <div class="project-list">
      <div v-if="loading" class="loading">正在加载项目列表...</div>
      <div v-else-if="error" class="error">{{ error }}</div>
      <div v-else class="project-items">
        <div 
          v-for="project in projects" 
          :key="project.id" 
          class="project-item"
        >
          <el-checkbox 
            v-model="project.selected" 
            @change="onProjectSelect"
          >
            {{ project.name }}
          </el-checkbox>
        </div>
      </div>
    </div>
    
    <div class="selector-footer">
      <div class="selected-info">
        已选择 {{ selectedCount }} 个项目
      </div>
      <div class="footer-actions">
        <el-button type="primary" @click="confirmSelection">确认选择</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProjectSelector',
  data() {
    return {
      projects: [],
      loading: false,
      error: null,
      selectedCount: 0
    }
  },
  mounted() {
    this.loadProjects();
  },
  methods: {
    async loadProjects() {
      this.loading = true;
      this.error = null;
      try {
        // 获取用户信息
        const userInfoRes = await axios.get('/api/user/info');
        const userInfo = userInfoRes.data;
        const authority = userInfo.authority;
        const employeeId = userInfo.employeeId;
        
        let url;
        if (authority == 1) {
          url = `/api/projects`;
        } else {
          url = `/api/projects/byEmployee?employeeId=${employeeId}`;
        }
        const response = await axios.get(url);
        if (response.data.success) {
          this.projects = response.data.data.map(project => ({
            ...project,
            selected: false
          }));
        } else {
          this.error = '获取项目列表失败: ' + (response.data.message || '未知错误');
        }
      } catch (error) {
        this.error = '获取项目列表失败: ' + error;
      } finally {
        this.loading = false;
      }
    },
    selectAll() {
      this.projects.forEach(project => {
        project.selected = true;
      });
      this.updateSelectedCount();
    },
    clearAll() {
      this.projects.forEach(project => {
        project.selected = false;
      });
      this.updateSelectedCount();
    },
    onProjectSelect() {
      this.updateSelectedCount();
    },
    updateSelectedCount() {
      this.selectedCount = this.projects.filter(project => project.selected).length;
    },
    confirmSelection() {
      const selectedProjects = this.projects.filter(project => project.selected);
      this.$emit('selection-confirmed', selectedProjects);
    },
    cancel() {
      this.$emit('selection-cancelled');
    }
  }
}
</script>

<style scoped>
.project-selector {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 24px;
  max-width: 600px;
  margin: 32px auto;
}

.selector-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.selector-header h2 {
  margin: 0;
  color: #1e293b;
  font-size: 20px;
  font-weight: 600;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.project-list {
  min-height: 300px;
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 16px;
}

.loading, .error {
  text-align: center;
  padding: 40px;
  color: #64748b;
}

.error {
  color: #ef4444;
}

.project-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.project-item {
  padding: 8px 12px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.project-item:hover {
  background-color: #f8fafc;
}

.selector-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
}

.selected-info {
  color: #64748b;
  font-size: 14px;
}

.footer-actions {
  display: flex;
  gap: 12px;
}
</style> 